export const sagePalette = {
  surface: {
    base: '#FCFDFC',
    raised: '#E7E9E7',
    deep: '#F8FAF8',
    card: '#FFF',
    active: '#484B47'
  },
  content: {
    primary: '#091203',
    secondary: 'hsl(120, 5.2%, 52.3%)',
    title: 'hsl(120,4%,13%)',
    hover: 'hsl(120, 6%, 56.1%)'
  },
  muted: {
    DEFAULT: '#41443b',
    foreground: '#8d918d'
  },
  primary: {
    light: 'hsl(167, 168, 166)',
    DEFAULT: '#484B47',
    dark: 'hsl(165, 82%, 31.9%)',
    50: '#FCFDFC',
    100: '#F8FAF8',
    200: '#FCFDFC',
    300: '#E7E9E7',
    400: '#DFE2DF',
    500: '#D7DAD7',
    600: '#CCCFCC',
    700: '#B9BCB8',
    800: '#898E87',
    900: '#7F847D'
  },
  secondary: {
    light: 'hsl(240, 96.7%, 97.4%)',
    DEFAULT: 'hsl(240, 91.5%, 95.5%)',
    dark: 'hsl(240, 85.1%, 93%)'
  },
  accent: {
    // semantic colors
    DEFAULT: '#E7E9E7',
    info: 'hsl(206, 100%, 50%)',
    success: 'hsl(142, 76%, 36%)',
    error: 'hsl(0, 84%, 60%)',
    warning: 'hsl(30, 100%, 50%)'
  },
  border: {
    // Base borders
    default: 'hsl(220, 13%, 91%)',
    subtle: 'hsl(220, 13%, 95%)',
    emphasis: 'hsl(220, 13%, 85%)',

    // Interactive states
    hover: 'hsl(220, 13%, 80%)',
    focus: 'hsl(220, 90%, 50%)',
    active: 'hsl(220, 13%, 75%)',
    selected: 'hsl(220, 90%, 50%)',

    // Semantic borders
    success: 'hsl(142, 76%, 36%)',
    error: 'hsl(0, 84%, 60%)',
    warning: 'hsl(30, 100%, 50%)',
    info: 'hsl(206, 100%, 50%)'
  }
}
